import { paletteHelper, AIMd, Button } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { usePcaChatModalContext } from '../../contexts/PcaChatModalContext';

const StyledCompareButton = styled(Button)`
  color: ${paletteHelper('textBrand')};
`;

export const CompareButton = () => {
  const { setPcaChatModalState } = usePcaChatModalContext();

  return (
    <StyledCompareButton
      sizeVariant="medium"
      variant="outline"
      icon={<AIMd />}
      className="header-compare-button"
      onClick={() => setPcaChatModalState('welcome')}
    >
      Compare
    </StyledCompareButton>
  );
};
